import { attachSubjects as e } from "../messages/attachSubjects.mjs";
import { useAiStreamReader as t } from "../stream/AiStreamReaderContext.mjs";
import { useCallback as n, useRef as r, useState as i } from "react";
import { adminAiApi as a, aiApi as o } from "@maat/api-ai";
import { AiChatArtifactType as s } from "@maat/ai";
//#region src/hooks/useAiChatStream.ts
var c = 50, l = ({ onBeforeSend: l, surface: u = "user" } = {}) => {
	let d = t(), [f, p] = i([]), [m, h] = i(null), [g, _] = i(!1), [v, y] = i(""), [b, x] = i(null), S = r(""), C = r(null), w = r(null), T = r([]), E = r([]), D = n(() => {
		w.current &&= (clearInterval(w.current), null);
	}, []), O = n(async (t) => {
		if (g) return;
		let n = new AbortController();
		C.current = n, S.current = "", T.current = [], E.current = [];
		let { apiMessage: r, subjects: i, pageContext: f } = l ? l(t) : {
			apiMessage: t,
			subjects: void 0,
			pageContext: void 0
		};
		p((e) => [...e, {
			role: "user",
			content: t,
			subjects: i
		}]), y(""), _(!0), x(null), w.current = setInterval(() => {
			y(S.current);
		}, c);
		try {
			let t = u === "admin" ? await a.streamChat(r, m ?? void 0, n.signal) : await o.streamChat(r, m ?? void 0, n.signal, f);
			for await (let r of d(t, n.signal)) try {
				let t = JSON.parse(r.data);
				switch (t.type) {
					case "chunk":
						S.current += t.content;
						break;
					case "done": {
						D();
						let e = S.current, n = T.current.length > 0 ? [...T.current] : void 0, r = E.current.length > 0 ? [...E.current] : void 0;
						y(e), p((i) => [...i, {
							role: "model",
							content: e,
							artifacts: n,
							id: t.messageId ?? void 0,
							followUps: r
						}]), t.conversationId && h(t.conversationId), y(""), _(!1), T.current = [];
						return;
					}
					case "artifact":
						if (t.artifactType === s.MessageSubject) {
							let n = t.data ?? [];
							p((t) => e(t, n));
							break;
						}
						T.current.push({
							artifactType: t.artifactType,
							data: t.data
						});
						break;
					case "followups":
						E.current = Array.isArray(t.followUps) ? t.followUps : [];
						break;
					case "error":
						D(), x(t.message || "Unknown error"), y(""), _(!1);
						return;
				}
			} catch {}
			if (D(), S.current) {
				let e = S.current;
				y(e), p((t) => [...t, {
					role: "model",
					content: e
				}]);
			}
			y(""), _(!1);
		} catch (e) {
			if (D(), e.name === "AbortError") {
				S.current && p((e) => [...e, {
					role: "model",
					content: S.current
				}]), y(""), _(!1);
				return;
			}
			x(e instanceof Error ? e.message : String(e)), y(""), _(!1);
		}
	}, [
		g,
		m,
		D,
		l,
		d,
		u
	]), k = n(() => {
		C.current?.abort(), D();
	}, [D]);
	return {
		messages: f,
		conversationId: m,
		isStreaming: g,
		streamingContent: v,
		error: b,
		send: O,
		abort: k,
		reset: n(() => {
			k(), p([]), h(null), y(""), x(null);
		}, [k])
	};
};
//#endregion
export { l as useAiChatStream };
